import React from "react";
import { useIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import { MemoizedDefaultChip } from "../chip/ChipRenderer.js";
import { ChipType, ChipVariant } from "../chip/types.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { useFilterSelectClasses, useGeneralSelectClasses } from "./selectStyle.js";
function MultiSelectWithTextCounterValue({
  selected,
  enumFormatter,
  label,
  emptyValue,
  options,
  maxWidth
}) {
  let formattedValues = [];
  const { formatMessage } = useIntl();
  if (selected?.length) {
    formattedValues = enumFormatter ? selected.map((s) => enumFormatter(s)).map((s) => typeof s === "string" ? s : formatMessage(s)) : selected.map((s) => {
      const label2 = options.find((o) => o.value === s)?.label;
      return label2 ? typeof label2 === "string" ? label2 : formatMessage(label2) : s;
    });
    formattedValues = [...new Set(formattedValues)];
  }
  const { classes } = useFilterSelectClasses();
  const { classes: generalSelectClasses } = useGeneralSelectClasses();
  const valuesLength = formattedValues?.length;
  return /* @__PURE__ */ React.createElement(Box, { className: generalSelectClasses.selectedValueEllipsis, style: { maxWidth }, "data-testid": "multiselectLabel" }, valuesLength > 0 ? /* @__PURE__ */ React.createElement(
    MemoizedDefaultChip,
    {
      className: classes.selectTotalChip,
      value: `${valuesLength}`,
      variant: ChipVariant.Blue,
      type: ChipType.Mark,
      hideTooltip: true
    }
  ) : null, label ? /* @__PURE__ */ React.createElement(Typography, { variant: "body1", className: classes.selectLabel, component: "span" }, /* @__PURE__ */ React.createElement(LocalizedText, { label })) : /* @__PURE__ */ React.createElement(React.Fragment, null), /* @__PURE__ */ React.createElement(Typography, { variant: "body1", component: "span" }, valuesLength > 0 ? formattedValues.join(", ") : /* @__PURE__ */ React.createElement(LocalizedText, { label: emptyValue })));
}
export {
  MultiSelectWithTextCounterValue
};
//# sourceMappingURL=MultiSelectWithTextCounterValue.js.map
